import { Create, SimpleForm, useNotify, useRedirect } from 'react-admin';
import { __t } from '../../i18n/t';
import DevRequestFields, { DEFAULT_VALUES, toPayload } from './DevRequestForm';
import InternalGate from './InternalGate';

const DevRequestCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  return (
    <InternalGate>
      <Create
        title="Novo pedido ao dev"
        transform={toPayload}
        mutationOptions={{
          onSuccess: (data: any) => {
            notify(__t('Rascunho salvo. Confira o texto e confirme o envio.'), { type: 'success' });
            redirect('show', 'dev-requests', data?.id, undefined, { sendNow: true });
          },
        }}
      >
        <SimpleForm defaultValues={DEFAULT_VALUES}>
          <DevRequestFields />
        </SimpleForm>
      </Create>
    </InternalGate>
  );
};

export default DevRequestCreate;
